import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import {
	buttonTypographySx,
	modalBackdropSx,
	modalContentStyle,
} from '../../../styles/patterns';

export const PdfModal = ({ url, open, onClose }) => {
	return (
		<Modal open={open} onClose={onClose} sx={modalBackdropSx}>
			<div
				style={{
					...modalContentStyle,
					margin: '20px',
					width: '100%',
				}}
			>
				<IconButton
					edge="end"
					color="inherit"
					aria-label="Close"
					onClick={onClose}
					style={{
						alignSelf: 'flex-end',
						paddingTop: '0px',
						paddingBottom: '0px',
					}}
				>
					<CloseIcon />
				</IconButton>
				<div
					style={{
						display: 'flex',
						alignSelf: 'flex-start',
						gap: '10px',
						marginBottom: '10px',
					}}
				>
					<Button
						href={url}
						variant="outlined"
						color="primary"
						size="small"
						download
						endIcon={<DownloadIcon />}
					>
						<Typography variant="h5" sx={buttonTypographySx}>
							Download
						</Typography>
					</Button>
				</div>
				<iframe
					src={url}
					title="Pattern"
					style={{
						height: '80vh',
						width: '100%',
					}}
				/>
			</div>
		</Modal>
	);
};
